import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer } from 'react-toastify';
import MiPedido from '../MiPedido/MiPedido';

/* =====================================================
   🔒 MODO SOLO CARTA DIGITAL
   👉 true  = NO se permiten pedidos
   👉 false = pedidos habilitados
===================================================== */
const SOLO_CARTA = true;

export default function Cart() {

    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [estado, setEstado] = useState(null);

    /* ================= FECHAS ================= */
    let now = new Date();
    let offset = -3 * 60;
    let argentinaTime = new Date(now.getTime() + offset * 60 * 1000);
    let createdAt = argentinaTime.toISOString().slice(0, 19).replace('T', ' ');

    /* ================= CARGA INICIAL ================= */
    useEffect(() => {
        cargarProductos();
        fetchEstado();
    }, []);

    useEffect(() => {
        let total = 0;
        cartItems.forEach(item => {
            total += item.precio * item.cantidad;
        });
        setTotalPrice(total);
    }, [cartItems]);

    const fetchEstado = async () => {
        try {
            const res = await fetch(`${baseURL}/estado.php`);
            const data = await res.json();
            setEstado(data.estado);
        } catch (error) {
            console.error(error);
        }
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(res => res.json())
            .then(data => setProductos(data.productos || []));
    };

    useEffect(() => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const items = cart.map(cartItem => {
            const producto = productos.find(p => p.idProducto === cartItem.idProducto);
            return producto ? { ...producto, cantidad: cartItem.cantidad, items: cartItem.items } : null;
        }).filter(Boolean);
        setCartItems(items);
        setLoading(false);
    }, [productos]);

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    /* ================= PEDIDOS BLOQUEADOS ================= */
    const crearPedido = async () => {
        if (SOLO_CARTA) {
            Swal.fire(
                'Solo carta digital',
                'Este menú es solo informativo. Realizá tu pedido con el personal.',
                'info'
            );
            return;
        }
    };

    return (
        <div>
            <ToastContainer />

            {/* ================= BOTÓN CARRITO ================= */}
            {!SOLO_CARTA && (
                <button onClick={() => setModalIsOpen(true)} className='cartIconFixed'>
                    {cartItems.length > 0 && <span>{cartItems.length}</span>}
                    <FontAwesomeIcon icon={faShoppingCart} />
                </button>
            )}

            {/* ================= MODAL CARRITO ================= */}
            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={() => setModalIsOpen(false)}
            >
                <div className='deFLex'>
                    <button onClick={() => setModalIsOpen(false)}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <MiPedido />
                </div>

                {estado !== 'Abierto' && (
                    <p className='nohay'>
                        El establecimiento se encuentra cerrado.<br />
                        Consulte horarios de atención.
                    </p>
                )}

                {estado === 'Abierto' && (
                    <>
                        {cartItems.length === 0 ? (
                            <p className='nohay'>No hay productos</p>
                        ) : (
                            <>
                                <div className="modal-content-cart">
                                    {loading ? (
                                        <p>Cargando...</p>
                                    ) : (
                                        cartItems.map((item, index) => (
                                            <div key={item.idProducto} className='cardProductCart'>
                                                <Anchor to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                    <img src={obtenerImagen(item)} alt="" />
                                                </Anchor>
                                                <div>
                                                    <h3>{item.titulo}</h3>
                                                    <strong>{moneda} {item.precio}</strong>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>

                                <h4>Total: {moneda} {totalPrice}</h4>

                                {!SOLO_CARTA && (
                                    <button className='btn' onClick={() => setModalIsOpen2(true)}>
                                        Finalizar pedido
                                    </button>
                                )}
                            </>
                        )}
                    </>
                )}
            </Modal>

            {/* ================= MODAL FINALIZAR ================= */}
            <Modal
                isOpen={modalIsOpen2}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={() => setModalIsOpen2(false)}
            >
                <button onClick={crearPedido} className='btn'>
                    Finalizar pedido
                </button>
            </Modal>
        </div>
    );
}